import classes from "./About.module.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useState, useContext, useRef } from "react";
import { SwiperSlide, Swiper } from "swiper/react";
import Modal from "react-bootstrap/Modal";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'swiper/css/effect-fade';
import { Pagination, Navigation, Autoplay, EffectFade } from "swiper/modules";
import { blurContext } from "./BlurContext";
import Container from "react-bootstrap/Container";

function About() {
	//state for displaying modal
	const [showModal, setShowModal] = useState(false);

	const progressCircle = useRef(null);
	const progressContent = useRef(null);
	const onAutoplayTimeLeft = (s, time, progress) => {
		progressCircle.current.style.setProperty("--progress", 1 - progress);
		progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
	};

	//import blur context to blur modal backdrop when modal is active
	const { changeBlurState } = useContext(blurContext);

	return (
		<div className={classes.main}>
			<Container>
				<Row>
					<Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6}>
						<div className={classes.description}>
							<h4>
								DC WEARS : Distinguished Elegance, Unwavering
								Reliability
							</h4>
							<p>
								Welcome to the world of DC WEARS, where we are
								passionate about not only enhancing your style
								but elevating it to new heights through the
								seamless integration of timeless fashion and an
								unwavering commitment to quality. Our garments
								are more than just fabric and stitches; they
								serve as a canvas for self-expression, allowing
								you to communicate your unique personality and
								values through the art of fashion. At the heart
								of our brand lies a deep-rooted belief in the
								power of Distinguished Elegance and Unwavering
								Reliability.{" "}
							</p>
							<p>
								These principles guide every step of our
								creative process, ensuring that our creations
								aren't just articles of clothing but genuine
								statements of who you are. From the moment you
								embrace one of our pieces, you'll immediately
								sense the difference. Our attention to detail is
								second to none, resulting in a fit that not only
								meets but exceeds your expectations, ensuring
								you look and feel your best. Whether you're
								preparing for a momentous occasion or embracing
								the beauty of everyday life, DC WEARS stands as
								your reliable companion on your stylish journey.
							</p>
							<p>
								In each stitch and seam, you'll discover the
								harmonious fusion of tradition and innovation.
								Our designs encapsulate the essence of classic
								sophistication while effortlessly incorporating
								contemporary flair, reflecting your multifaceted
								personality and tastes. At DC WEARS, we aren't
								just creators of clothing; we are crafters of
								experiences, curators of moments, and we weave
								the fabric of cherished memories that last a
								lifetime.
							</p>
							<p>
								Elevate your wardrobe by exploring our
								thoughtfully curated collections, and in doing
								so, you'll undoubtedly elevate your confidence.
								Discover a world of style and comfort at DC
								WEARS, where Distinguished Elegance and
								Unwavering Reliability join hands, presenting an
								unparalleled fashion experience that transcends
								the ordinary and becomes an integral part of
								your extraordinary story.
							</p>
						</div>
					</Col>
					<Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6}>
						<div className={classes.carousel}>
							<Swiper
								modules={[Pagination, Navigation, Autoplay, EffectFade]}
								effect={"fade"}
								navigation={true}
								pagination={{ clickable: true }}
								autoplay={{
									delay: 3000,
									disableOnInteraction: false,
								}}
								onAutoplayTimeLeft={onAutoplayTimeLeft}
								loop={true}
								spaceBetween={0}
								slidesPerView={1}
							>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_women_attire.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_women_attire2.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_women_attire3.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_suit3.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_me2.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_dracula.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_men.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_men1.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_men2.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_suit2.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_suit1.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwearswomen_attire4.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwearswomen_attire6.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwearswomen_attire5.jpg')`,
										}}
									></div>
								</SwiperSlide>
								<SwiperSlide>
									<div
										className={classes.carouselImg}
										style={{
											backgroundImage: `url('./images/dcwears_main.png')`,
										}}
									></div>
								</SwiperSlide>
								<div
									className={classes.autoplayProgress}
									slot="container-end"
								>
									<svg
										viewBox="0 0 48 48"
										ref={progressCircle}
									>
										<circle cx="24" cy="24" r="20"></circle>
									</svg>
									<span ref={progressContent}></span>
								</div>
							</Swiper>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
						<div className={classes.watchVideo}>
							<p
								style={{
									fontFamily: "Libre Baskerville, sans-serif",
									margin: "2rem",
								}}
							>
								Step into a world of timeless fashion and
								unmatched quality
							</p>
							<Button
								className="rounded-5 p-3 bg-white mb-3 text-dark"
								variant="success"
								onClick={() => {
									setShowModal(true);
									changeBlurState(true);
								}}
							>
								<img
									src="/images/video.png"
									alt="play-video"
									width={20}
								/>
								{"  "}
								Watch Video
							</Button>
						</div>
					</Col>
				</Row>
			</Container>

			<Modal
				show={showModal}
				onHide={() => {
					setShowModal(false);
					changeBlurState(false);
				}}
				centered
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>DC WEARS</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<video controls className={classes.videoPlayer}>
						<source src="./videos/DC.mp4" type="video/mp4" /> Sorry
						your browser doesn't support playing videos
					</video>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="success"
						className="rounded-1 "
						onClick={() => {
							setShowModal(false);
							changeBlurState(false);
						}}
					>
						Close Video
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
export default About;
